import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import {
  getRecipient,
  getBalance,
  getHasAwaiting,
} from 'Redux/selectors/transactions'
import {
  orderPayout,
  getAllTransactions,
} from 'Redux/actions/transactionsActions'
import { getPayoutsList } from 'Redux/selectors/payouts'
import { getPayouts } from 'Redux/actions/payoutsActions'
import { getUser } from 'Redux/selectors/auth'
import Component from './Balance'

const selector = createStructuredSelector({
  curator: getUser,
  recipient: getRecipient,
  balance: getBalance,
  payouts: getPayoutsList,
  hasAwaiting: getHasAwaiting,
})

const actions = {
  orderPayout,
  getPayouts,
  getAllTransactions,
}

export default connect(selector, actions)(Component)
